import React from "react";
import * as S from "./styles";

import iconUser from "../../assets/navbar/Pessoa_fisica_on_light_blue.svg";

import Navbar from "../../components/Navbar";

import { useParams } from "react-router-dom";

export default function Manutencao() {
  const { name } = useParams();

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Cadastro de {name ? `${name}` : ""}</S.Title>
              <S.Description>
                Está tela {name ? `${"(" + name + ")"}` : ""} está em
                desenvolvimento
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
      </S.Wrapper>
    </>
  );
}
